import { render, staticRenderFns } from "./RatingAdd.vue?vue&type=template&id=4983586c&scoped=true"
import script from "./RatingAdd.vue?vue&type=script&lang=js"
export * from "./RatingAdd.vue?vue&type=script&lang=js"
import style0 from "./RatingAdd.vue?vue&type=style&index=0&id=4983586c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983586c",
  null
  
)

export default component.exports